import React from 'react'
import PaymentStatus from '../PaymentStatus/PaymentStatus';
import './PaymentSent.scss';
import TimeElapsed from '../TimeElapsed';
import { config } from '../../../../config';

export const PaymentSent = ({createTime, sentAmount}) => {
    return (
        <div className="payment-pending-component">
              <div className="payment-pending-component__container">
                  <PaymentStatus status={config.statuses.payment_sent} />

                  <p className="payment-pending-component__container--text"> 
                    You’ve successfully sent a payment of <b>{sentAmount} {config.currencies.ADA.symbol}.</b> We’re waiting for it to be confirmed by the network.
                  </p>

                  <TimeElapsed createTime={createTime} />
              </div>
        </div>
    )
}

export default PaymentSent;
